import { PROCESS_LABELS } from '../actions/types';

export default function (state = null, action) {
  switch (action.type) {
    case PROCESS_LABELS:
      return action.payload;
    default:
      return state;
  }
}